import { useGameFormData } from "./useGameFormData";
import { useGameForm } from "./useGameForm";
import { GameStatus } from "../types/game-status";
import { PlayerAction } from "../types";

type UseWaitableFormConfig = {
  gameSubmit?: () => PlayerAction;
  customSubmit?: () => void;
  waitingFor: GameStatus[];
  waitHeader: string;
  titles: string[];
  submitText?: string;
  validation?: { isReady: boolean };
  subHeaders?: string[];
  readyFlash?: boolean;
  countdownThreshold?: number;
};

export const useWaitableForm = (config: UseWaitableFormConfig) => {
  const formData = useGameFormData();
  const { handleSubmit, avatarHeaderProps } = useGameForm({
    gameSubmit: config.gameSubmit,
    customSubmit: config.customSubmit,
    playerState: formData.playerState,
  });

  const waitableProps = {
    waitingFor: config.waitingFor,
    waitHeader: config.waitHeader,
  };

  const formPageProps = {
    // Pass header props instead of creating an element
    // FormPage will handle memoization internally
    headerProps: {
      titles: config.titles,
      ...avatarHeaderProps,
    },
    ...formData,
    ready: config.validation?.isReady ?? true,
    submitText: config.submitText,
    onSubmit: handleSubmit,
    subHeaders: config.subHeaders,
    readyFlash: config.readyFlash,
    countdownThreshold: config.countdownThreshold,
  };

  return { waitableProps, formPageProps };
};

